import { SIQConversationListItemTheme } from "./SIQConversationListItemTheme";
export class SIQConversationTheme {
  backgroundColor = "null";
  ListItem = new SIQConversationListItemTheme();
}
//# sourceMappingURL=SIQConversationTheme.js.map